import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  toastDetails: { isToggle: false, message: "", status: "warning" },
  isDataRefetch: false,
};

const utilSlice = createSlice({
  name: "util",
  initialState,
  reducers: {
    setToastDetails(state, { payload }: PayloadAction<any>) {
      state.toastDetails = payload;
    },
    setDataRefetch(state, { payload }: PayloadAction<any>) {
      state.isDataRefetch = payload;
    },
  },
});

export const { setToastDetails, setDataRefetch } = utilSlice.actions;

export default utilSlice.reducer;
